import { type PaginationState, type SortingState } from '@tanstack/react-table'
import React, { useState } from 'react'

import EmployerOpenEnrollmentFiltersView from './EmployerOpenEnrollmentFiltersView'
import EmployerOpenEnrollmentTable, { type EmployerOpenEnrollmentFilters } from './EmployerOpenEnrollmentTable'

interface EmployerOpenEnrollmentProps {
  years: number[]
}

const EmployerOpenEnrollment: React.FC<EmployerOpenEnrollmentProps> = ({ years }) => {
  // Select the latest year by default
  const defaultYear = years.length > 0 ? Math.max(...years) : new Date().getFullYear()

  const [openEnrollmentYear, setOpenEnrollmentYear] = useState(defaultYear)
  const [filters, setFilters] = useState<EmployerOpenEnrollmentFilters>({})

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 20,
  })

  const [sorting, setSorting] = useState<SortingState>([])

  const openEnrollmentYearOptions = years.map(year => ({
    value: year,
    label: `${year}`,
  }))

  return (
    <div className='space-y-6'>
      <div className='flex justify-between items-center'>
        <h1 className='text-2xl font-semibold text-gray-900'>
          Employer Open Enrollment
        </h1>

        <div className='flex items-center space-x-2'>
          <label htmlFor='open-enrollment-year-select' className='text-sm font-medium text-gray-700'>
            Open Enrollment Year:
          </label>
          <select
            id='open-enrollment-year-select'
            value={openEnrollmentYear}
            onChange={(e) => {
              const newYear = parseInt(e.target.value, 10)
              setOpenEnrollmentYear(newYear)
              setPagination({ pageIndex: 1, pageSize: 20 })
            }}
            className='block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
          >
            {openEnrollmentYearOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <EmployerOpenEnrollmentFiltersView
        filters={filters}
        setFilters={setFilters}
        pagination={pagination}
        setPagination={setPagination}
      />

      <EmployerOpenEnrollmentTable
        openEnrollmentYear={openEnrollmentYear}
        filters={filters}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
      />
    </div>
  )
}

export default EmployerOpenEnrollment
